import {
  isSensitiveInformationError,
  isUserMessage,
} from '@cascade/react/conversations';
import type { TMessage } from '@cascade/react/conversations';
import type {
  TChatParticipantMessageProps,
  TChatToolCallStep,
} from '@cascade/ui-library';
import type { TChatMessageOptions } from './ChatThread.types.ts';
import { buildConversationMessage } from '#helpers/index.ts';

const buildToolCallSteps = (message: TMessage): TChatToolCallStep[] => {
  const toolCalls = message.toolCalls ?? [];

  return toolCalls.map((toolCall) => ({
    id: toolCall.call_id,
    label: toolCall.message,
    status: toolCall.status,
  }));
};

export const buildChatMessage = (
  message: TMessage,
  { userName, agentName, waitingLabels }: TChatMessageOptions,
): TChatParticipantMessageProps => {
  const conversationMessage = buildConversationMessage(message, {
    userName,
    agentName,
  });

  const chatMessage = { ...conversationMessage, messageId: message.key };

  if (isUserMessage(message)) {
    return chatMessage;
  }

  const toolCalls = buildToolCallSteps(message);
  const isWaiting = message.status === 'pending' && toolCalls.length === 0;

  return {
    ...chatMessage,
    isLoading: isWaiting,
    loadingLabels: waitingLabels,
    toolCalls,
  };
};

export const findRefusedQuestion = (
  messages: TMessage[],
): TMessage | undefined => {
  const requestId = messages.findLast((message) =>
    isSensitiveInformationError(message.error),
  )?.requestId;

  if (!requestId) {
    return undefined;
  }

  return messages.find(
    (message) => message.requestId === requestId && isUserMessage(message),
  );
};
